import { Offer, UpsellExclusions } from '@dgx-pr-spa/shared/util';
import { createSelector } from '@ngrx/store';
import { getOffer } from '@view-offers/store/selectors/offers.selector'; // TODO dependency
import { ItemOfferState } from '../reducers/item.offer.reducer';
import { getAdditionalServicesState } from './state.selector';

export const getItemOfferState = createSelector(
  getAdditionalServicesState,
  (state) => state?.itemOffer
);

export const getItemOffer = createSelector(
  getItemOfferState,
  (itemOffer: ItemOfferState) => itemOffer?.data
);

export const getItemOfferLoading = createSelector(
  getItemOfferState,
  (itemOffer: ItemOfferState) => itemOffer?.loading
);

export const getItemOfferLoaded = createSelector(
  getItemOfferState,
  (itemOffer: ItemOfferState) => itemOffer?.loaded
);

export const getItemOfferError = createSelector(
  getItemOfferState,
  (itemOffer: ItemOfferState) => !!itemOffer?.error
);

export const getItemOfferUpsell = createSelector(
  getOffer,
  (offer: Offer) => offer?.upsell_flag
);

export const getUpsellEnabled = createSelector(
  getOffer,
  (offer: Offer) => offer?.upsell_reason !== UpsellExclusions.UPSELL_DISABLED
);
